<div class="w-full text">
    <p class="w-full text">
        <span class="text-center">
            SIN INFORMACIÓN REGISTRADA.
        </span>
    </p>
</div>
<button *ngIf="mostrarBotonFinalizar()" (click)="finalizarDiligencia()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Finalizar
</button>
<button *ngIf="mostrarBotonFinalizarSimple()" (click)="finalizarDiligencia()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Finalizar
</button>
<button *ngIf="mostrarBotonEnviar()" (click)="enviarDiligencia()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Enviar
</button>
<button *ngIf="mostrarBotonFinalizarEnviar()" (click)="finalizarAndEnviar()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Finalizar y enviar
</button>
<button *ngIf="canAceptarOrRechazar()" (click)="aceptarSolicitud()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Aceptar
</button>
<button *ngIf="canAceptarOrRechazar()" (click)="rechazarSolicitud()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Rechazar
</button>
<button *ngIf="canAsignar()" (click)="asignarSolicitud()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Asignar
</button>
<button *ngIf="canReasignar()" (click)="asignarSolicitud()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Reasignar
</button>
<button *ngIf="validarEstatusDiligencia()" (click)="responderTarea()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Preparar respuesta
</button>
<button *ngIf="validarEnviarRespuesta()" (click)="enviarRespuesta()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Enviar respuesta
</button>

<button *ngIf="validarSolicitarAutorizacionSimple()" (click)="mostrarSolicitarAutorizacionDialog()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Solicitar autorización
</button>

<button *ngIf="validarSolicitarAutorizacionSolicitud()" (click)="firmarAndSolicitarAutorizacionesDialog()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Solicitar autorización
</button>

<button *ngIf="validarAutorizar()" (click)="autorizarDilgiencia()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Autorizar
</button>

<button *ngIf="validarMultipleAutorizar()" (click)="solicitarMultipleAutorizacion()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Autorizar y solicitar otra autorización
</button>

<button *ngIf="validarRechazarAutorizar()" (click)="rechazarAutorizacion()" mat-raised-button color="accent" class="subscribe-button" aria-label="SUBSCRIBE">
    Rechazar autorización
</button>